import React, { useState, useEffect } from 'react';
import { Chart } from 'react-google-charts';
import { Doughnut } from 'react-chartjs-2';

const SalesPieChart = ({ salesSku, salesQuery, salesData }) => {
	const [currentData, setCurrentData] = useState([]);
	const [salesName, setSalesName] = useState('Brand');

	function capitalize(str) {
		const lower = str.toLowerCase();
		return str.charAt(0).toUpperCase() + lower.slice(1);
	}

	// console.log('salesSku', salesSku);
	// console.log('salesData', salesData);
	useEffect(() => {
		if (salesData && salesData.pieData) {
			const filterSales = salesSku[0].value; // sales Quantity, Sales
			const filterCategory = salesSku[1].value; // type Brand , Chain
			let data = [];

			if (Object.keys(salesData.pieData).length) {
				data = filterCategory
					? salesData.pieData[filterCategory]
					: salesData.pieData['Brand'];
			}
			if (filterCategory) {
				setSalesName(capitalize(filterCategory));
				data = salesData.pieData[filterCategory];
			}
			// console.log('data', data);
			if (filterSales && data) {
				data = data[filterSales];
			} else if (data) {
				data = data['Sales'];
			}

			if (data) {
				const newD = [['Sale', 'Sales data'], ...data];
				if (newD) {
					setCurrentData(newD);
				}
			}
		}
	}, [salesData, salesSku]);

	// console.log('salesData', salesData);

	return (
		<div>
			<Chart
				height={'330px'}
				chartType='PieChart'
				loader={<div>Loading Chart</div>}
				data={currentData}
				options={{
					width: '100%',
					title: salesName,
					pieHole: 0.4,
					sliceVisibilityThreshold: 0,
					legend: {
						position: 'right',
						alignment: 'center',
						// orientation: 'vertical',
					},
					titleTextStyle: {
						fontSize: 21,
						color: '#666',
						alignment: 'center',
					},
				}}
				// rootProps={{ 'data-testid': '1' }}
			/>
		</div>
	);
};

export default SalesPieChart;
